export default "__VITE_ASSET__958ozeCv__"